import { Link } from "react-router-dom";

type OwnProps = {
  target?: string;
  className?: string;
  onClick?: $TSFixMeFunction;
  children?: React.ReactNode;
  outside?: boolean;
  onAuxClick?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  className: "",
  target: undefined,
  onClick: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Clickable({
  target,
  onClick,
  children,
  className,
  onAuxClick,
  outside = false,
}: Props) {
  const handleOnClick = (event: $TSFixMe) => {
    event.preventDefault();
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onClick(event);
  };

  const handleOnAuxClick = (event: $TSFixMe) => {
    event.preventDefault();
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onAuxClick(event);
  };

  const linkProps = {
    ...(onClick && { onClick: handleOnClick }),
    ...(onAuxClick && { onAuxClick: handleOnAuxClick }),
    ...(target && { to: target }),
  };

  if (outside && target) {
    return (
      <div className={`clickable navigable outside ${className}`}>
        {/* @ts-expect-error TS(2322) FIXME: Type '{ to?: string | undefined; onAuxClick?: ((ev... Remove this comment to see the full error message */}
        <Link {...linkProps} />
        {children}
      </div>
    );
  }

  if (target)
    return (
      // @ts-expect-error TS(2322) FIXME: Type '{ children: ReactNode; to?: string | undefin... Remove this comment to see the full error message
      <Link className={`clickable navigable ${className}`} {...linkProps}>
        {children}
      </Link>
    );

  if (onClick)
    return (
      <button
        className={`clickable navigable ${className}`}
        type="button"
        onClick={onClick}
        onAuxClick={onAuxClick}
      >
        {children}
      </button>
    );

  return <div className="clickable non-navigable">{children}</div>;
}

Clickable.defaultProps = defaultProps;

export default Clickable;
